// import React, { useEffect, useState } from "react";
// import Select from '../../atoms/Select/Select';
// import useRequest from "../../../context/useRequest";

// const FormCountryCodes = ({ value, onChange }) => {
//   const [countryCodes, setCountryCodes] = useState([]);
//   const { sendRequest } = useRequest();


//   useEffect(() => {
//     const fetchCountryCodes = async () => {
//       try {
//         const response = await sendRequest({
//           method: "GET",
//           url: "/countryCodes",
//         });
//         // console.log(response)
//         if (response.status && response.data) {
//           setCountryCodes(response.data);
//           // console.log(response.data)
//         }
//       } catch (error) {
//         console.error("Error fetching country codes:", error);
//       }
//     };

//     fetchCountryCodes();
//   }, [sendRequest]);
//   const handleChange = (e) => {
//     const selectedValue = e.target.value;
//     setCountryCodes(selectedValue)
//     const event = {
//       target: {
//         name: "country_code", 
//         value: selectedValue,
//       },
//     };

//     onChange(event); 
//   };
//   return (
//     <Select
//       name="country_code"
//       value={value}
//       onChange={handleChange} 
//       label="Country Code"
//     >
//       <option value="">Select Country Code</option>
//       {countryCodes.map((item, index) => (
//         <option key={index} value={item.id}>
//           {item.emoji} +{item.phonecode} {item.name}
//         </option>
//       ))}
//     </Select>
//   );
// };

// export default FormCountryCodes;


import React, { useEffect, useState } from "react";
import Select from '../../atoms/Select/Select';
import useRequest from "../../../context/useRequest";

const FormCountryCodes = ({ value, onChange }) => {
  const [countryCodes, setCountryCodes] = useState([]);
  const { sendRequest } = useRequest();

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const response = await sendRequest({
          method: "GET",
          url: "/countryCodes",
        });
        // Assuming response.data is an array
        if (response.status && Array.isArray(response.data)) {
          setCountryCodes(response.data);
        }
      } catch (error) {
        console.error("Error fetching country codes:", error);
      }
    };

    fetchCountryCodes();
  }, [sendRequest]);

  const handleChange = (e) => {
    const selectedValue = e.target.value;

    // Pass the selected value without altering countryCodes
    const event = {
      target: {
        name: "country_code",
        value: selectedValue,
      },
    };

    onChange(event); // Trigger parent component's onChange
  };

  return (
    <Select
      name="country_code"
      value={value}
      onChange={handleChange}
      label="Country Code"
    >
      <option value="">Select Country Code</option>
      {Array.isArray(countryCodes) && countryCodes.length > 0 ? (
        countryCodes.map((item, index) => (
          <option key={index} value={item.id}>
            {item.emoji} +{item.phonecode} {item.name}
          </option>
        ))
      ) : (
        <option>No country codes available</option>
      )}
    </Select>
  );
};

export default FormCountryCodes;
